document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-product-tabs] .product-detail-tab');
  if (!tab) return;
  var tabs = tab.closest('[data-product-tabs]');
  var targetId = tab.getAttribute('data-tab-target');
  tabs.querySelectorAll('.product-detail-tab').forEach(function (button) {
    var active = button === tab;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  tabs.querySelectorAll('.product-detail-panel').forEach(function (panel) {
    panel.classList.toggle('is-active', panel.id === targetId);
  });
});


// Buberry collection dropdown routing: keep shoppers on Shopify's native
// /collections route and show only the requested editable collection section.
(function () {
  var allowed = ['bamboo', 'silicone', 'stainless', 'snack-jar'];

  function applyCollectionView() {
    var path = window.location.pathname.replace(/\/+$/, '');
    if (path !== '/collections') return;

    var key = (window.location.hash || '').replace('#', '').toLowerCase();
    var main = document.getElementById('MainContent');
    if (!main) return;

    var wrappers = Array.prototype.slice.call(main.querySelectorAll(':scope > .shopify-section'));
    // Shopify preview may wrap sections differently; fall back to closest wrappers.
    if (!wrappers.length) {
      wrappers = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    }

    if (allowed.indexOf(key) === -1) {
      wrappers.forEach(function (el) { el.style.display = ''; });
      document.body.classList.remove('buberry-single-collection-view');
      return;
    }

    var target = document.getElementById(key);
    if (!target) {
      wrappers.forEach(function (el) { el.style.display = ''; });
      return;
    }

    var targetWrapper = target.closest('.shopify-section') || target;
    wrappers.forEach(function (el) {
      el.style.display = (el === targetWrapper || el.contains(target)) ? '' : 'none';
    });
    document.body.classList.add('buberry-single-collection-view');
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

  document.addEventListener('DOMContentLoaded', applyCollectionView);
  window.addEventListener('hashchange', applyCollectionView);
  document.addEventListener('shopify:section:load', applyCollectionView);
})();
